import { render, staticRenderFns } from "./MInviewItem.vue?vue&type=template&id=2e12cb82&"
import script from "./MInviewItem.vue?vue&type=script&lang=ts&"
export * from "./MInviewItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports